// extracted by mini-css-extract-plugin
export default {"accept":"VerificationButton_accept__xyrX+","reject":"VerificationButton_reject__R483z"};